import type { RedoOnboardingV2RpcClient } from "@redotech/redo-onboarding-api/client";
import { toPreferredLocale } from "@redotech/redo-onboarding-api/schema/update-preferred-locale";

/** Saves the dashboard language without waiting; failures are ignored, as in the dashboard. */
export function savePreferredLocale(
  rpcClient: RedoOnboardingV2RpcClient,
  locale: string,
): void {
  const preferredLocale = toPreferredLocale(locale);
  if (preferredLocale) {
    rpcClient
      .updatePreferredLocale({ locale: preferredLocale })
      .catch(() => undefined);
  }
}
